export default __webpack_public_path__ + "static/media/reports.f94c7419.svg";